import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { useIntlMessages } from 'src/hooks';

import { Form, Input } from 'src/components/common';

import getValidationSchema from './validationSchema';

import './index.scss';

const PersonalData = ({ defaultValues, onSubmit, isSpeechTherapist }) => {
  const messages = useIntlMessages();

  return (
    <div className="personal-data-container">
      <span className="personal-data-container__title">
        {messages.label.personalData}
      </span>
      <Form
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        validationSchema={getValidationSchema(isSpeechTherapist)}
        buttonClassName="collapsed"
        submitBtnLabel={messages.button.saveChanges}
        formClassName="personal-data-container__form"
      >
        {!isSpeechTherapist && (
          <Input label={messages.label.childName} name="childName" />
        )}
        <Input label={messages.label.fullName} name="fullName" />
        <Input label={messages.label.email} name="email" type="email" />
        <Input label={messages.label.phoneNumber} name="phoneNumber" />
      </Form>
    </div>
  );
};

PersonalData.propTypes = {
  defaultValues: PropTypes.shape({
    childName: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSpeechTherapist: PropTypes.bool.isRequired,
};

export default memo(PersonalData);
